import React from 'react'
import styled from '../../config/theme'

export default function Card ({ title, children }: CardProps) {
  return (
    <Container>
      <Title>{title}</Title>
      <Content>
        {children}
      </Content>
    </Container>
  )
}

export interface CardProps {
  title: string
  children: React.ReactNode
}

const Container = styled.div`
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 3px 9px 0 rgba(169,184,200,.15);
`

const Title = styled.div`
  color: #212529;
  font-weight: 500;
  font-size: 1.125rem;
  margin-bottom: 20px;
`

const Content = styled.div`
  
`
